import Table from '@/components/Table'
import { TableData } from '@/components/Table/type'
import { useCompaniesQuery } from '@/queries/useCompaniesQuery'
import { Company } from '@/types/Companies'
import { createColumnHelper } from '@tanstack/react-table'
import { useMemo } from 'react'
import DadosMestreHeader from '../components/DadosMestreHeader' 
import DadosMestreHeaderActions from '../components/DadosMestreHeaderActions' 
import DefaultColumn from '@/components/Table/components/DefaultColumn'
import { useTable } from '@/hooks/useTable'

export type CompaniesTable = TableData<Company>

const columnHelper = createColumnHelper<Company>()

const MasterDataCompanies = () => {
    const {
        table,  
        selectedRows,  
        onClickMultiDelete, 
        setTable,
    } = useTable<Company>('')
  
    const { data, isFetching, isPending, refetch } = useCompaniesQuery()
 
    const memoData = useMemo(() => data || [], [data])
    const memoColumns = useMemo(
        () => [
            columnHelper.accessor('SK_EMPRESA', {
                id: 'SK_EMPRESA',
                header: 'Cod. Empresa',
                size: 140,
            }),
            columnHelper.accessor('DD_GRUPO_EMPRESA', {
                id: 'DD_GRUPO_EMPRESA',
                header: 'Cod. Grupo Empresa',
                size: 170
            }),
            columnHelper.accessor('DS_ABREVIATURA', {
                id: 'DS_ABREVIATURA',
                header: 'Abreviatura Empresa',
                size: 200,
            }),
            columnHelper.accessor('DD_CNPJ', {
                id: 'DD_CNPJ',
                header: 'CNPJ',
                size: 160,
            }), 
            columnHelper.accessor(({ DD_ATIVO }) => {
                return  DD_ATIVO == 1 ? 'ATIVO' : 'INATIVO'
            }, { 
                id: 'DD_ATIVO',
                header: 'Status', 
                size: 100,
            }), 
        ],
        []
    )

    return (
        <div className="w-full h-full p-4 overflow-hidden">
            <Table<CompaniesTable>
                data={memoData}
                columns={memoColumns}
                getRowId={(row) => row.SK_EMPRESA.toString()}
                isLoading={isPending}
                isFetching={isFetching}
                getTableInstance={(table) => setTable(table)} 
                tableHeader={
                    <DadosMestreHeader
                        title={`Empresas`}
                        onDelete={onClickMultiDelete}
                        selectedRows={
                            table
                                ?.getFilteredRowModel()
                                .flatRows.filter((row) => selectedRows[row.id])
                                .length
                        }
                    />
                }
                tableActions={
                    <DadosMestreHeaderActions 
                        onRefech={refetch} 
                    />
                } 
                defaultColumn={{
                    cell: ({ getValue }) => (
                        <DefaultColumn>{getValue() as string}</DefaultColumn>
                    ),
                }}
            /> 
        </div>
    )
}

export default MasterDataCompanies
